import { CustomElement } from '@aurelia/runtime-html';
export const name = "custom-row";
export const template = "<template >\n    <span>${message}</span>\n</template>\n";
export default template;
export const dependencies = [  ];
export const bindables = {"message":{"name":"message"}};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
